<!-- tabs, P6:556-563 -->
<nav class="cx-rtabs" aria-label="Review categories">
  <span class="cx-rtab stated"><span class="l">Stated in your CV</span><span class="c dn">✓ {{ StatedCount }}</span></span>
  @for (c of Categories; track c) {
    <button class="cx-rtab" [class.on]="c === Category" type="button" [attr.aria-current]="c === Category ? 'true' : null" (click)="OpenCategory(c)">
      <span class="l">{{ LabelOf(c) }}</span><span class="c" [class.dn]="IsDone(c)">{{ TabCount(c) }}</span>
    </button>
  }
</nav>

@if (NoteOpen) {
  <div class="cx-info" role="note">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/></svg>
    <span>These are in your CV, but implied rather than stated, or read with less certainty. Each card quotes the line it came from so you can check us.</span>
    <button type="button" aria-label="Dismiss" (click)="DismissInfo()">×</button>
  </div>
}

<div class="cx-rv">
  @if (ShowViewer) {
    <ra-cx-pdf-viewer [Url]="DownloadUrl" [Highlight]="CurrentHighlights" [FileName]="Cv?.fileName ?? ''" (LoadFailed)="ViewerFailed.emit()" />
  }

  <div>
    @if (Current; as cur) {
      <div class="cx-qtop"><span>{{ ProgressText }}</span></div>
      <div class="cx-card cx-q">
        <div class="cx-qtags">
          @for (chip of ChipsOf(cur); track chip; let first = $first) {
            <span [class.k]="first" [class.im]="!first">{{ chip }}</span>
          }
        </div>
        <div class="prog" role="progressbar" aria-label="Review progress" aria-valuemin="0" aria-valuemax="100" [attr.aria-valuenow]="ProgressPercent"><i [style.width.%]="ProgressPercent"></i></div>
        <h2>{{ cur.name }}</h2>
        <div class="wy">
          <div class="k">WHY WE THINK SO</div>
          @for (q of cur.quotes; track $index) {
            <blockquote>{{ q.text }}</blockquote>
            @if (q.page !== null) { <div class="from">From: page {{ q.page }}</div> }
          }
        </div>
        <div class="cx-qact">
          <button class="a" type="button" (click)="OnAccept()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>Accept <kbd>A</kbd>
          </button>
          <button class="d" type="button" (click)="OnDecline()">Decline <kbd>D</kbd></button>
        </div>
      </div>
      @if (Pending.length > 1) {
        <div class="cx-next">
          <div class="cx-nexth"><span>NEXT UP</span><button class="cx-link" type="button" (click)="OnAcceptAll()">Accept all {{ Pending.length }}</button></div>
          @for (r of Pending; track r.providerTagID) {
            <button class="cx-nrow" [class.on]="r.providerTagID === cur.providerTagID" type="button" (click)="Pick(r.providerTagID)">
              <span class="nt"><b>{{ r.name }}</b>@if (r.quotes[0]?.page !== null && r.quotes[0]) { <span class="nf">From: page {{ r.quotes[0].page }}</span> }</span>
              <em>{{ ConfidenceLabel(r) }}</em>
            </button>
          }
        </div>
      }
    } @else {
      <div class="cx-card cx-done">
        <span class="cx-dot" aria-hidden="true"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span>
        <h2>{{ DoneTitle }}</h2>
        <p>{{ DoneBody }}</p>
        <button class="cx-btn pri" type="button" (click)="OpenNext()">{{ DoneButton }}</button>
      </div>
    }
  </div>
</div>
